import { Base } from "./Base";

export interface HospitalLogo extends Base {
  content:string;
  hospitalId:number;
}

export const initHospitalLogo:HospitalLogo = {
  id: -1,
  key: -1,
  hospitalId:-1,
  content:'',
};
